module.exports = __webpack_public_path__ + "img/top_icon.37aaf1a2.png";